module.exports = __webpack_public_path__ + "static/media/logEdit.8b97be8c.svg";